<template>
  <div class="container-fluid my-3 target" style="min-height:50vh">
    <popUp v-if="toggle" v-on:doClose="close" :size="'middle'">
      <div class="pop-title" slot="title">
        <h5>{{selectedName}}</h5>
      </div>
      <div slot="info" >
        <table class="rwd-table">
          <tbody>
            <tr>
              <th>{{ copy.no }}</th>
              <th>{{ copy.usedAt }}</th>
              <th>{{ copy.item }}</th>
              <th>{{ copy.pointsDeducted }}</th>
              <th>{{ copy.details }}</th>
            </tr>
            <tr v-for="(item, index) in studentRecord" :key="index">
              <td class="rwd-td" :data-th="copy.no">
                {{index+1}}
              </td>
              <td class="rwd-td" :data-th="copy.usedAt">
                {{item.created_at}}
              </td>
              <td :data-th="copy.item">
                {{ displayName(item) }}
              </td>
              <td :data-th="copy.pointsDeducted">
                {{item.points}}
              </td>
              <td :data-th="copy.details">
                <a href="javascript:void();" @click="goPersonalInfo(item)">{{ copy.details }}</a>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination v-if="personalPageCount>1 || studentRecord.length>0" class="m-auto pt-2" :current="pageIndex" :total="personalPageCount" v-on:page="toPage"/>
        <div v-if="studentRecord.length===0" class="remind my-5 d-flex align-items-center" >
          <h3 class="m-auto">{{ copy.noData }}</h3>
        </div>
      </div>
    </popUp>
    <div class="row">
      <div class="col-12">
        <div class="d-flex menu">
          <div @click="goTitlePage('AI-Record')"  class="title d-sm-flex pointer" :class="{'active' : title === 'AI-Record'}">
            <div class="my-auto">
              {{ copy.classRecords }}
            </div>
          </div>
          <div @click="goTitlePage('AI-Record-Personal')" class="title  d-sm-flex pointer" :class="{'active' : title === 'AI-Record-Personal'}">
            <div class="my-auto">
              {{ copy.personalRecords }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 d-md-flex my-3 justify-content-between align-items-center filter-bar">
        <div class="d-flex align-items-center filter-controls">
          <div v-if="title === 'AI-Record-Personal'" class="filter-field">
            <label class="m-0 mr-2">{{ copy.studentName }}:</label>
            <v-select class="student-select" :clearable="false" :placeholder="copy.select" v-model="studentSelected" :reduce="name => name.id" :get-option-label="displayName" :options="studentList">
              <span slot="no-options">
                {{ copy.noResults }}
              </span>
            </v-select>
          </div>
          <div v-if="title === 'AI-Record'" class="filter-field">
            <label class="mr-2">{{ copy.queryItem }}:</label>
            <select class="filter-select" v-model="typeSelected">
              <option value="0" disabled>{{ copy.select }}</option>
              <option v-for="(item, index) in type" :key="index" :value="item.type">
                <span>
                  {{ displayName(item) }}
                </span>
              </option>
            </select>
          </div>
          <div class="filter-field">
            <div class="d-flex align-items-center">
              <label class="m-0 mr-2">{{ copy.dateRange }}:</label>
              <date-picker :clearable="false" valueType="format" v-model="range" type="date" range :placeholder="copy.selectDateRange"></date-picker>
            </div>
          </div>
        </div>
        <div>
          <!-- <button v-if="getAIGroupSummary?.length>0"  type="button" @click="downloadExcel" class="btn btn-success">下載報表</button>
          <button v-else type="button" disabled class="btn btn-success">下載清單</button>
          <button type="button" @click="sendReport()" class="btn btn-success mx-2">寄送全班報表</button> -->
        </div>
      </div>
      <div v-if="title === 'AI-Record'" class="col-12" style="min-height:40vh">
        <div>
          <table class="rwd-table mt-3">
            <tbody>
              <tr>
                <th>{{ copy.account }}</th>
                <th>{{ copy.name }}</th>
                <th>{{ copy.usageCount }}</th>
                <th>{{ copy.lastUsedAt }}</th>
                <th>{{ copy.totalPoints }}</th>
                <th>{{ copy.details }}</th>
              </tr>
              <tr v-for="(item, index) in AISummary" :key="index">
                <td class="rwd-td" :data-th="copy.account">
                  {{item.account}}
                </td>
                <td :data-th="copy.name">
                  {{ displayName(item) }}
                </td>
                <td :data-th="copy.usageCount">
                  {{item.total_times}}
                </td>
                <td :data-th="copy.lastUsedAt">
                  {{item.last_used_at}}
                </td>
                <td :data-th="copy.totalPoints">
                  {{item.total_points}}
                </td>
                <td :data-th="copy.details">
                  <a
                    href="javascript:void();"
                    :class="{ disabled: isGEPTSelected }"
                    @click="openPersonalRecord(item)"
                  >{{ copy.details }}</a>
                </td>
              </tr>
            </tbody>
          </table>
          <pagination v-if="pageCount>0" class="m-auto pt-4" :current="pageIndex" :total="pageCount" v-on:page="toPage"/>
        </div>
        <div v-if="AISummary.length===0" class="remind mt-5">
          <h3>{{ dataInfo }}</h3>
        </div>
      </div>
      <div v-else class="col-12" style="min-height:40vh">
        <div>
          <table class="rwd-table mt-3">
            <tbody>
              <tr>
                <th>{{ copy.no }}</th>
                <th>{{ copy.usedAt }}</th>
                <th>{{ copy.item }}</th>
                <th>{{ copy.pointsDeducted }}</th>
                <th>{{ copy.details }}</th>
              </tr>
              <tr v-for="(item, index) in studentRecord" :key="index">
                <td class="rwd-td" :data-th="copy.no">
                  {{index+1}}
                </td>
                <td class="rwd-td" :data-th="copy.usedAt">
                  {{item.created_at}}
                </td>
                <td :data-th="copy.item">
                  {{ displayName(item) }}
                </td>
                <td :data-th="copy.pointsDeducted">
                  {{item.points}}
                </td>
                <td :data-th="copy.details">
                  <a href="javascript:void();" @click="goPersonalInfo(item)">{{ copy.details }}</a>
                </td>
              </tr>
            </tbody>
          </table>
          <pagination v-if="personalPageCount>1 || studentRecord.length>0" class="m-auto pt-2" :current="pageIndex" :total="personalPageCount" v-on:page="toPage"/>
        </div>
        <div v-if="studentRecord.length===0" class="remind mt-5">
          <h3>{{ copy.noData }}</h3>
        </div>
      </div>
		</div>
  </div>
</template>
<script>
// @ is an alias to /src
import Pagination from '@/components/Pagination.vue'
import PopUp from '@/components/PopUp.vue'
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import api from '../../store/api'
export default {
  name: 'AI_Record',
  data () {
    return {
      AISummary: [],
      typeSelected: '0',
      selectedName: '',
      studentSelected: null,
      type: [],
      studentList: [],
      studentRecord: [],
      range: [ moment(new Date(new Date().getTime())).format('YYYY-MM-DD'), moment(new Date()).format('YYYY-MM-DD')],
      title: this.$route.name,
      pageIndex: 1,
      pageCount: 0,
      personalPageCount: 0,
      pageSize: 10,
      dataInfo: '',
      toggle: false,
      popupStudentId: null,
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n ? this.$i18n.locale : 'tw'
    },
    copy () {
      const copy = {
        tw: {
          classRecords: '班級學習記錄查',
          personalRecords: '個人學習記錄查',
          studentName: '學員姓名',
          select: '請選擇',
          noResults: '找不到搜尋結果',
          queryItem: '查詢項目',
          dateRange: '區間',
          selectDateRange: '請選擇日期區間',
          account: '帳號',
          name: '姓名',
          usageCount: '使用次數',
          lastUsedAt: '最後使用時間',
          totalPoints: '總使用點數',
          details: '詳細資料',
          no: '序號',
          usedAt: '使用時間',
          item: '項目',
          pointsDeducted: '扣除點數',
          noData: '無考試資料'
        },
        en: {
          classRecords: 'Class Learning Records',
          personalRecords: 'Personal Learning Records',
          studentName: 'Student Name',
          select: 'Select',
          noResults: 'No results found',
          queryItem: 'Query Item',
          dateRange: 'Date Range',
          selectDateRange: 'Select a date range',
          account: 'Account',
          name: 'Name',
          usageCount: 'Usage Count',
          lastUsedAt: 'Last Used At',
          totalPoints: 'Total Points Used',
          details: 'Details',
          no: 'No.',
          usedAt: 'Used At',
          item: 'Item',
          pointsDeducted: 'Points Deducted',
          noData: 'No data'
        }
      }

      return copy[this.currentLocale] || copy.tw
    },
    groupId () {
      return this.$route.params.groupId
    },
    isGEPTSelected () {
      return this.typeSelected === 'GEPT'
    }
  },
  mounted () {
    this.dataInfo = this.copy.select
    this.getTypes()
    this.getStudentList()
  },
  watch: {
    typeSelected (val) {
      this.pageIndex = 1
      if (this.title==='AI-Record' && val !== '0' && val !== 0 && val !== null) {
        this.getAIGroupSummary ()
      } else if (this.title !== 'AI-Record' && this.studentSelected !== null) {
        this.getPersonalRecord()
      }
    },
    studentSelected (val) {
      this.pageIndex = 1
      if (val === null) return
      this.getPersonalRecord()
    },
    range (val) {
      if (this.toggle && this.popupStudentId) {
        this.getPersonalRecord(this.popupStudentId)
      } else if (this.title === 'AI-Record') {
        this.getAIGroupSummary()
      } else {
        this.getPersonalRecord()
      }
    },
  },
  methods: {
    async getTypes () {
      const { data } = await api.get(`/usage_records/types`)
      this.type = data
    },
    async getStudentList() {
      const params = {
        page: 1,
        pageSize: 500
      }
      const { data } = await api.get(`groups/${this.groupId}/students`, { params })
      this.studentList = data.data
      this.studentSelected = null
    },
    displayName (item) {
      if (!item) {
        return ''
      }

      if (this.currentLocale === 'en') {
        return item.name_en || item.display_name || item.name || ''
      }

      return item.name || item.display_name || item.name_en || ''
    },
    async getAIGroupSummary() {
      const params = {
        type: this.typeSelected,
        begin_at: this.range[0] + ' 00:00:00',
        end_at:  this.range[1] + ' 23:59:59',
        page: this.pageIndex,
        pageSize: this.pageSize
      }
      const { data } = await api.get(`usage_records/groups/${this.groupId}`, { params })
      this.AISummary = data.data
      this.pageIndex = data.current_page
      this.pageCount = data.total_pages
      if (data.data.length === 0 ) {
        this.dataInfo = this.copy.noData
      }
    },
    async getPersonalRecord(id) {
      const params = {
        type: this.typeSelected,
        begin_at: this.range[0] + ' 00:00:00',
        end_at:  this.range[1] + ' 23:59:59',
        page: this.pageIndex,
        pageSize: this.pageSize
      }
      const { data } = await api.get(`usage_records/students/${id? id:this.studentSelected}`, { params })
      this.studentRecord = data.data
      this.pageIndex = data.current_page
      this.personalPageCount = data.total_pages
      if (data.data.length === 0 ) {
        this.dataInfo = this.copy.noData
      }
    },
    goTitlePage(el) {
      // 如果傳入的 el 和當前的 title 一樣，就直接 return
      if (this.title === el) return
      this.title = el
      if (el === 'AI-Record') {
        this.$router.push({ name: el, params: { groupId: this.groupId } })
      } else {
        this.$router.push({ name: el, params: { groupId: this.groupId, studentId: 0 } })
      }
    },
    goPersonalInfo (el) {
      const routeConfigMap = {
        AI_CORRECT: {
          name: 'viewGenerate',
          params: { aiType: 'letter', promptId: el.record_id, generateType: 'correct' }
        },
        AI_LETTER: {
          name: 'viewGenerate',
          params: { aiType: 'letter', promptId: el.record_id, generateType: 'generate' }
        },
        AI_SPEECH: {
          name: 'viewGenerate',
          params: { aiType: 'speech', promptId: el.record_id, generateType: 'generate' }
        },
        AI_CHAT: {
          name: 'viewChat',
          params: { lang: 'en' },
          query: { conversation_id: el.record_id }
        },
        AI_CHAT_JP: {
          name: 'viewChat',
          params: { lang: 'jp' },
          query: { conversation_id: el.record_id }
        },
        GEPT: {
          name: 'gept_report_formal',
          params: { record_id: el.record_id }
        },
        HIGHSCHOOL_WRITING: {
          name: 'quiz_report_formal',
          params: { record_id: el.record_id }
        }
      }
      const routeConfig = routeConfigMap[el.type]
      if (!routeConfig) return

      const routeData = this.$router.resolve(routeConfig)
      window.open(routeData.href, '_blank')
    },
    openPersonalRecord (el) {
      if (this.isGEPTSelected) return
      this.toggle = true
      this.selectedName = el.name
      this.popupStudentId = el.student_id
      this.pageSize = 8
      this.pageIndex = 1
      this.getPersonalRecord (el.student_id)
    },
    toPage (toPage) {
      this.pageIndex = toPage
      if (this.toggle && this.popupStudentId) {
        this.getPersonalRecord(this.popupStudentId)
      } else if (this.title === 'AI-Record') {
        this.getAIGroupSummary()
      } else {
        this.getPersonalRecord()
      }
    },
    close (close) {
      this.studentRecord = []
      this.toggle = close
      this.popupStudentId = null
      this.pageIndex = 1
      this.pageSize = 10
    }
  },
  components: {
    Pagination,
    DatePicker,
    PopUp
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/styles/color.scss";
  .menu {
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    .title {
      margin: 10px 30px 10px 0;
    }
  }
  .active {
    // color: red;
    font-weight: bolder;
  }
  .filter-bar {
    flex-wrap: wrap;
    gap: 12px 16px;
  }
  .filter-controls {
    flex-wrap: wrap;
    gap: 8px 16px;
    min-width: 0;
  }
  .filter-field {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 0;
    min-width: 0;
  }
  .filter-select {
    max-width: min(100%, 560px);
    padding: 3px 8px;
  }
  .filter-field ::v-deep .mx-datepicker,
  .filter-field ::v-deep .v-select {
    max-width: 100%;
  }
  .target-box {
    // width: 270px;
    height: 180px;
    overflow: hidden;
    background-color: #ededed;
    border: .5px solid rgb(202, 202, 202);
    border-radius: 5px;
    .target-title {
      padding: 8px;
      background-color: #0041b9;
      color: #fff;
    }
    .target-content {
      text-align: left;
      padding: 20px;
      height: 80%;
    }
    .progress {
      margin: 5px;
      height: 10px;
      background-color: #fff;
      .progress-bar {
        background-color: red;
      }
    }
  }
  table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  th {
    overflow:hidden;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }

  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table tbody th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
.main-title {
  background: rgb(24, 97, 255);
  border: none !important;
}

@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}

.student-select {
  width: 200px;
}
a.disabled {
  color: #999;
  cursor: not-allowed;
  pointer-events: none;
  text-decoration: none;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table tbody th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>
